// pages/AdminPage.js
import React, { useState, useEffect } from 'react';
import AdminDashboard from '../components/AdminDashboardPage/AdminDashboard';
import AdminLogin from '../components/AdminDashboardPage/AdminLogin';

function AdminPage() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // On component mount, check localStorage
    const loginStatus = localStorage.getItem('adminLoggedIn');
    if (loginStatus === 'true') {
      setIsLoggedIn(true);
    }
  }, []);

  const handleLoginSuccess = () => {
    localStorage.setItem('adminLoggedIn', 'true'); // Save login status
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminLoggedIn'); // Clear login status
    setIsLoggedIn(false);
  };

  return (
    <>
      {isLoggedIn ? (
        <AdminDashboard onLogout={handleLogout} />
      ) : (
        <AdminLogin onLoginSuccess={handleLoginSuccess} />
      )}
    </>
  );
}

export default AdminPage;



// // pages/AdminPage.js
// import React from 'react';
// import AdminDashboard from '../components/AdminDashboardPage/AdminDashboard';

// function AdminPage() {
//   return <AdminDashboard />;
// }

// export default AdminPage;